
export const truncateDate = (date: Date): Date => {
    // 秒以下を切り捨てる
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

// 日付差を計算する
export const diff_days = (fromDate: Date|null, toDate: Date|null): number => {
    
    //どちらか nullの場合は、-1を返す
    if( fromDate === null || toDate === null ) return( -1 );
    
    const dateFrom: Date = truncateDate(fromDate);
    const dateTo: Date = truncateDate(toDate);
    // 日付差はミリ秒単位のため、24hours * 60min * 60sec * 1,000ms で割る
    const dayUnit = 24 * 60 * 60 * 1000;
    return (dateTo.valueOf() - dateFrom.valueOf()) / dayUnit;
};

// 日付から文字列に変換する関数
export const getStringFromDate = (date: Date|null) => {

    if (!date) return '';

    const year_str = date.getFullYear();
    //月だけ+1すること(1月の時は0、2月の時は1になるため)
    const month_str = 1 + date.getMonth();
    const day_str = date.getDate();
    
    let format_str = 'YYYY/MM/DD';
    format_str = format_str.replace(/YYYY/g, String(year_str));
    format_str = format_str.replace(/MM/g, String(month_str));
    format_str = format_str.replace(/DD/g, String(day_str));
    return format_str;
};
